const auctions_card = [
  {
    id: 1,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 2,
    image: "/image.png",
    title: "Node Monkey #12",
    name: "Node Monkey",
    price: 4,
  },
  {
    id: 3,
    image: "/image.png",
    title: "The sister of knife",
    name: "CosplayX",
    price: 7,
  },
  {
    id: 4,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 5,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 6,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 7,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 8,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 9,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
  {
    id: 10,
    image: "/image.png",
    title: "Mysterious Egg",
    name: "FAST",
    price: 2,
  },
];

export default auctions_card;
